import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { TranslationSetFragmentDoc, CoverImageFragmentDoc } from '../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FoldersGrid_FoldersQueryVariables = Types.Exact<{
  input: Types.AdminLibraryInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type FoldersGrid_FoldersQuery = { __typename?: 'Query', AdminLibrary: { __typename?: 'LibraryItems', objects: Array<{ __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, folder?: { __typename?: 'Folder', id: string, position: string } | null }> } };

export type FolderLibraryItemFolderMembershipFragment = { __typename?: 'LibraryItemFolderMembership', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, folder?: { __typename?: 'Folder', id: string, position: string } | null }, folder?: { __typename?: 'Folder', id: string, position: string } | null };

export type UpdateFolderPositionMutationVariables = Types.Exact<{
  folderId: Types.Scalars['UUID']['input'];
  position: Types.Scalars['String']['input'];
}>;


export type UpdateFolderPositionMutation = { __typename?: 'Mutation', updateFolderPosition: { __typename?: 'FolderMutationResult', success: boolean, folder?: { __typename?: 'Folder', id: string, position: string } | null } };

export type FolderLibraryItemFragment = { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, folder?: { __typename?: 'Folder', id: string, position: string } | null };

export const FolderLibraryItemFragmentDoc = gql`
    fragment FolderLibraryItem on LibraryItem {
  id
  name {
    ...TranslationSet
  }
  description {
    ...TranslationSet
  }
  coverImage {
    ...CoverImage
  }
  folder {
    id
    position
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const FolderLibraryItemFolderMembershipFragmentDoc = gql`
    fragment FolderLibraryItemFolderMembership on LibraryItemFolderMembership {
  id
  libraryItem {
    ...FolderLibraryItem
  }
  folder {
    id
    position
  }
}
    ${FolderLibraryItemFragmentDoc}`;
export const FoldersGrid_FoldersDocument = gql`
    query FoldersGrid_Folders($input: AdminLibraryInput!, $pagination: PaginationInput) {
  AdminLibrary(input: $input, pagination: $pagination) {
    objects {
      ...FolderLibraryItem
    }
  }
}
    ${FolderLibraryItemFragmentDoc}`;

/**
 * __useFoldersGrid_FoldersQuery__
 *
 * To run a query within a React component, call `useFoldersGrid_FoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersGrid_FoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoldersGrid_FoldersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFoldersGrid_FoldersQuery(baseOptions: Apollo.QueryHookOptions<FoldersGrid_FoldersQuery, FoldersGrid_FoldersQueryVariables> & ({ variables: FoldersGrid_FoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoldersGrid_FoldersQuery, FoldersGrid_FoldersQueryVariables>(FoldersGrid_FoldersDocument, options);
      }
export function useFoldersGrid_FoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoldersGrid_FoldersQuery, FoldersGrid_FoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoldersGrid_FoldersQuery, FoldersGrid_FoldersQueryVariables>(FoldersGrid_FoldersDocument, options);
        }
export type FoldersGrid_FoldersQueryHookResult = ReturnType<typeof useFoldersGrid_FoldersQuery>;
export type FoldersGrid_FoldersLazyQueryHookResult = ReturnType<typeof useFoldersGrid_FoldersLazyQuery>;
export type FoldersGrid_FoldersQueryResult = Apollo.QueryResult<FoldersGrid_FoldersQuery, FoldersGrid_FoldersQueryVariables>;
export const UpdateFolderPositionDocument = gql`
    mutation UpdateFolderPosition($folderId: UUID!, $position: String!) {
  updateFolderPosition(folderId: $folderId, position: $position) {
    success
    folder {
      id
      position
    }
  }
}
    `;
export type UpdateFolderPositionMutationFn = Apollo.MutationFunction<UpdateFolderPositionMutation, UpdateFolderPositionMutationVariables>;

/**
 * __useUpdateFolderPositionMutation__
 *
 * To run a mutation, you first call `useUpdateFolderPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderPositionMutation, { data, loading, error }] = useUpdateFolderPositionMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useUpdateFolderPositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderPositionMutation, UpdateFolderPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderPositionMutation, UpdateFolderPositionMutationVariables>(UpdateFolderPositionDocument, options);
      }
export type UpdateFolderPositionMutationHookResult = ReturnType<typeof useUpdateFolderPositionMutation>;
export type UpdateFolderPositionMutationResult = Apollo.MutationResult<UpdateFolderPositionMutation>;
export type UpdateFolderPositionMutationOptions = Apollo.BaseMutationOptions<UpdateFolderPositionMutation, UpdateFolderPositionMutationVariables>;